/* unplugin-vue-components disabled */import { render } from "./file.vue?vue&type=template&id=4f417f45&scoped=true"
import script from "./file.vue?vue&type=script&lang=js"
export * from "./file.vue?vue&type=script&lang=js"

import "./file.vue?vue&type=style&index=0&id=4f417f45&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f417f45"]])

export default __exports__